<template>
	<div class="container page-container" v-if="dataReady">
	    <el-row :gutter="10">
	      <el-col :xs="24" :sm="24" :md="24" :lg="24">
	        <h1>Confirm new password</h1>
	      </el-col>
	    </el-row>
	</div>
</template>
<script>
  import { authService } from '../helpers/helpers'
  export default {
    name: 'confirm',

    data () {
      return {
        dataReady: false,
        auth: authService
      }
    },

    components: {
      // AppHeader
    },

    created () {
      this.auth.setNewPassword()
      this.dataReady = true
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// Confirm.vue?21743907